import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INoticeListResponse, Onboarding } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { NoticesService } from './notices.service';
import { PaginatedResult } from 'src/app/interfaces/global/global.model';

@Injectable({ providedIn: 'root' })
export class NoticesServiceImpl implements NoticesService {
    constructor(private store: Store<State>, private http: HttpClient) {}

    getNotices(): Observable<PaginatedResult<INoticeListResponse>> {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/notices`)),
            catchError((err) =>
                of({
                    docs: [],
                    totalDocs: 0,
                    offset: 0,
                    limit: 10,
                    totalPages: 0,
                    page: 1,
                    pagingCounter: 1,
                    hasPrevPage: false,
                    hasNextPage: false,
                    prevPage: null,
                    nextPage: 1,
                } as PaginatedResult<INoticeListResponse>),
            ),
            map((res) => res as PaginatedResult<INoticeListResponse>),
        );
    }

    getStats(): Observable<any[]> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get<INoticeListResponse[]>(`${env.baseUrl}/cerberus/notices/stats`).pipe(map((res) => res))));
    }
}

export const NOTICES_SERVICE_IMPL = {
    provide: NoticesService,
    useClass: NoticesServiceImpl,
};
